import { useAsync } from "@/shared/hooks/HookBase";
import { useCallback } from "react";
import type IUserPlanService from "../contracts/IUserPlanService";
import UserPlanService from "../services/UserPlanService";
import type AssignPlanRequest from "../models/AssignPlanRequest";
import type { PlanStatus } from "../valueObjects/PlanStatus";

const userPlanService: IUserPlanService = new UserPlanService();

export function useUserPlan() {
  const { loading, error, execute } = useAsync();

  const getUserPlan = useCallback(
    async (userId: string) => {
      return await execute(() => userPlanService.getUserPlan(userId));
    },
    [execute],
  );

  const assignPlan = useCallback(
    async (request: AssignPlanRequest) => {
      return await execute(() => userPlanService.assignPlan(request), { successMessage: "Plan asignado correctamente" });
    },
    [execute],
  );

  const updateStatus = useCallback(
    async (userId: string, status: PlanStatus) => {
      return await execute(() => userPlanService.updateStatus(userId, status), { successMessage: "Estado actualizado correctamente" });
    },
    [execute],
  );

  return {
    loading,
    error,
    getUserPlan,
    assignPlan,
    updateStatus,
  };
}
